export const formDefaultConf = {
    start: null, //'12:00',
    end: null, //'18:00',
    value: null, //13,
    days: [
        { id: '0', short: 'mon', value: true },
        { id: '1', short: 'tue', value: true },
        { id: '2', short: 'wed', value: true },
        { id: '3', short: 'thu', value: true },
        { id: '4', short: 'fri', value: true },
        { id: '5', short: 'sat', value: false },
        { id: '6', short: 'sun', value: false },
    ],
};

export const generateSurgeOptions = (t) => [
    {
        id: 'inherit',
        name: t('tariffs.surge_options.inherit'),
    },
    {
        id: 'on',
        name: t('tariffs.surge_options.on'),
    },
    {
        id: 'off',
        name: t('tariffs.surge_options.off'),
    },
];
